'use client';

import { useRef } from 'react';
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import Close from '@mui/icons-material/Close';
import ErrorRounded from '@mui/icons-material/ErrorRounded';
import InfoRounded from '@mui/icons-material/InfoRounded';
import WarningRounded from '@mui/icons-material/WarningRounded';
import IconButton from '@mui/material/IconButton';
import { closeSnackbar, SnackbarKey, SnackbarProvider as NotistackProvider } from 'notistack';

import { StyledIcon, StyledNotistack } from './styles';

type Props = {
  children: React.ReactNode;
};

const renderCloseAction = (snackbarId: SnackbarKey) => (
  <IconButton
    size='small'
    onClick={() => closeSnackbar(snackbarId)}
    sx={{ p: 0.5 }}
    data-testid='close-snackbar'
  >
    <Close sx={{ fontSize: 16 }} />
  </IconButton>
);

export default function SnackbarProvider({ children }: Props) {
  const notistackRef = useRef(null);

  return (
    <NotistackProvider
      ref={notistackRef}
      maxSnack={5}
      preventDuplicate
      autoHideDuration={3000}
      variant='success'
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      iconVariant={{
        info: (
          <StyledIcon color='info'>
            <InfoRounded />
          </StyledIcon>
        ),
        success: (
          <StyledIcon color='success'>
            <CheckCircleRounded />
          </StyledIcon>
        ),
        warning: (
          <StyledIcon color='warning'>
            <WarningRounded />
          </StyledIcon>
        ),
        error: (
          <StyledIcon color='error'>
            <ErrorRounded />
          </StyledIcon>
        ),
      }}
      Components={{
        default: StyledNotistack,
        info: StyledNotistack,
        success: StyledNotistack,
        warning: StyledNotistack,
        error: StyledNotistack,
      }}
      action={renderCloseAction}
    >
      {children}
    </NotistackProvider>
  );
}
